export class HRConfig {
  id:        string;
  name:      string;
}
